import { cronosClient } from "@/config/client"

export interface Module {
  id: string
  name: string
  progress: number
  units: Unit[]
}
export interface Unit {
  id: string
  name: string
  progress: number
}

interface GetGlobalSituationPayload {
  subjectId: string
  courseId?: string
}

export interface GetGlobalSituationResponse {
  progress: number
  weeklyProgress: number
  approvedActivities: number
  weekNumber: number
  approvedActivitiesDiff: number
  weeklyCourseProgressDiff: number
  minutesStudied: number
  minutesStudiedDiff: number
  moduleProgress: Module[] | null
}

export function getGlobalSituation(data: GetGlobalSituationPayload) {
  return cronosClient.post<GetGlobalSituationResponse, GetGlobalSituationPayload>(
    `/v1/courses/global-situation`,
    data,
  )
}
